import { defineComponent as _defineComponent } from 'vue'
import { cloneDeep } from 'lodash'
import Vue from 'vue'
import { computed, onMounted, ref, watch } from 'vue'

interface PropsType {
  data: any
  oriLine: string
  targetLine?: string
  isFromTask?: boolean
}

interface NestedObject {
  [key: string]: any
}


export default /*#__PURE__*/_defineComponent({
  __name: 'm-conflict-table',
  props: {
    data: null,
    oriLine: null,
    targetLine: null,
    isFromTask: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  data: any
  oriLine: string
  targetLine?: string
  isFromTask?: boolean
}

const keyMap = new Map([
  ['barCodeSetting', '板件条码设置'],
  ['boardGapsSetting', '排版间隙设置'],
  ['countertopSetting', '台面设置'],
  ['decimalSetting', '小数保留位数'],
  ['edgePlankSlotDirection', '靠边板槽放置'],
  ['holeFaceSetting', '孔槽集中面'],
  ['knife', '开料刀直径'],
  ['longPlankCuttingSetting', '长板加工'],
  ['surplusSetting', '余料设置'],
  ['genSimpleLabelBarcode', '生成简易格式标签条码'],
  ['boardGap', '排版间隙'],
  ['startPosition', '工位起始点'],
  ['counter_limit_able', '台面宽度限制开关'],
  ['counter_width', '台面宽度'],
  ['decimal', '小数保留位数'],
  ['sideBoardPlacing', '靠边板槽放置'],
  ['default', '系统默认'],
  ['inside', '大板内侧'],
  ['outside', '大板外侧'],
  ['throughHoleSlotSameSide', '打穿孔槽所在面跟随该小板上未穿孔槽'],
  ['custom_special_hole_slot_side', '特殊孔槽加工面自定义'],
  ['non_through_slot_two_side_cut', '设置不生效翻面两次打穿孔'],
  ['diameter', '开料刀直径'],
  ['longPlankCuttingEnable', '长板加工'],
  ['vacuumPumpPauseWay', '真空关闭方式'],
  ['after_all_plank', '整张大板切割后'],
  ['after_one_plank', '单块长板切割后'],
  ['longPlankShortExpandedSize', '首次切割-短边放量'],
  ['longPlankExpandedSize', '首次切割-长边放量'],
  ['longPlankMinLength', '长板分两次切割-长边超过'],
  ['longPlankShortMinLength', '长板分两次切割-短边超过'],
  ['curveSecondCutEnable', '异形板二次切割'],
  ['desMaterialSwitch', '指定材质开关'],
  ['desMaterialList', '指定材质'],
  ['generalPlankThick', '常规板厚度 ≥ '],
  ['single_door_thick', '门板厚度 ≥ '],
  ['cutGeneralPlank', '二次切割对象-常规板'],
  ['cutSingleDoor', '二次切割对象-门板'],
  ['specified_board_secondary_cutting', '指定板名切割'],
  ['force_board_name', '忽略尺寸/其他筛选条件，强制启用'],
  ['secondary_cutting_board_list', '指定板名切割板件名列表'],
  ['topLeft', '左上角'],
  ['bottomLeft', '左下角'],
  ['topRight', '右上角'],
  ['bottomRight', '右下角'],
  ['+x,+y', '左下角'],
  ['+x,-y', '左上角'],
  ['-x,+y', '右下角'],
  ['-x,-y', '右上角'],
  ['surplusPosition', '余料摆放位置'],
  ['uniqueBarCode', '板件条码唯一'],
  ['true', '开启'],
  ['false', '关闭'],
  ['highgloss_setting', '高光板设置'],
  ['highgloss_direction', '排版时小板高光面排在大板'],
  ['auto_high_gloss_reverse', '仅带有反面孔槽的大板自动翻面'],
  ['front', '正面'],
  ['back', '反面'],
  ['apertureSlotConcentrated', '槽集中面'],
  ['holeConcentrated', '孔集中面'],
  ['prorate_holes_slots_of_both_side', '按比例分配正反面孔槽'],
  ['percentage_of_back_hole_slot', '反面孔槽占比'],
  // 特殊孔槽自定义需求删除此选项[
  //   'processChainAndHoleOnBigPlaneBack',
  //   '拉直器和铰链杯孔放到大板反面加工',
  // ],
  ['xyReverse', 'XY轴互换'],
  ['cuttingPunchingSetting', '切割打孔方式'],
  ['throughTowSideToCut', '通孔打孔方式'],
  ['through_slot_two_side_cut', '通槽打穿方式'],
  ['movePlankSetting', '防跑板设置'],
  ['scattered_layout', '小板分散排版'],
  ['safe_length', '最小可吸住板件'],
  ['integrationDeviceSetting', '一体机设置'],
  ['enable_integration_device', '输出一体机加工文件'],
  ['aio_fixture_setting-aio_avoid_fixture', '孔槽避让夹手位置'],
  ['aio_fixture_setting-aio_first_fixture_height', '夹手1距边(H1)'],
  ['aio_fixture_setting-aio_second_fixture_height', '夹手2距边(H2)'],
  ['aio_fixture_setting-aio_fixture_direction', '夹手方向'],
  ['aio_fixture_setting-aio_fixture_length', '夹手长度(L)'],
  ['aio_fixture_setting-aio_fixture_width', '夹手宽度（W）'],
  ['sawSetting', '锯切雕刻机设置'],
  ['mentaoji_enable', '启用锯切雕刻机'],
  ['sawToLayout', '启用锯片厚度排版'],
  ['processType', '加工工艺'],
  ['weldingPlank', '焊接板'],
  ['doorFrame', '门套'],
  ['horizontalWidth', '锯片横切刀直径'],
  ['edgeNoSaw', '已封好不再切的大板边'],
  ['sameWidthPlank', '每张大板上只排相同宽度小板'],
  ['edgeNoSawSide', '已封好不再切的大板边'],
  ['L', '左侧'],
  ['R', '右侧'],
  ['T', '上侧'],
  ['B', '下侧'],
  ['trimmingSetting', '修边设置'],
  ['trimSide', '修边方向'],
  ['high_gloss_plank_no_rotate', '高光板不转板'],
])

// 孔槽类型
const typeMap = new Map([
  ['lightSlot', translateLang('灯槽')],
  ['CCPXHole', translateLang('三合一偏心孔')],
  ['ALS', translateLang('暗拉手槽')],
  [
    'straightener_slots_and_hinged_cup_holes',
    translateLang('拉直器槽和铰链杯孔'),
  ],
  ['normalHole', '常规孔'],
  ['normalSlot', '常规槽'],
  ['LockHole', '锁孔'],
  ['normal_hole', '常规孔'],
])
// 孔槽加工面
const surfaceMap: Map<'front' | 'back', string> = new Map([
  ['front', translateLang('大板正面')],
  ['back', translateLang('大板反面')],
])
// 比较值
const compareMap: Map<'gt' | 'lt' | 'eq', string> = new Map([
  ['gt', translateLang('大于')],
  ['lt', translateLang('小于')],
  ['eq', translateLang('等于')],
])
const spcialKeyMap = new Map([
  ['true', '翻面两次打穿'],
  ['false', '一次打穿'],
  ['topLeft', '左边、上边'],
  ['bottomLeft', '左边、下边'],
  ['topRight', '右边、上边'],
  ['bottomRight', '右边、下边'],
])

const tableData = ref<any[]>([])
const expandedArr = ref<string[]>([])
// 是否展示特殊孔槽自定义详细规则
const isShowSpecialRule = ref(true)

const getkeys = (data: any) => {
  const keys = Object.keys(data)

  return keys
}

const handleExpandTitle = (item: string) => {
  if (expandedArr.value.includes(item)) {
    expandedArr.value = expandedArr.value.filter((newVal) => item !== newVal)
  } else expandedArr.value.push(item)
}

function translateLang(key?: string) {
  return Vue.prototype.$translateLang(key as any)
}

/**
 * @desc 填充具体特殊孔槽自定义表格内容
 * @param item
 */
const fillSpecialHoleSlot = (item: any, index: number) => {
  if (!index || !item.special_hole_slot_side) return ['']
  return item
    ? item.special_hole_slot_side[index - 1].map(
        (it: { key: string; value: 'front' | 'back'; rules: any }) => {
          if (it.key.includes('normalHole')) {
            it.key = 'normalHole'
          }
          if (it.key.includes('normal_hole')) {
            it.key = 'normal_hole'
          }
          if (it.key.includes('normalSlot')) {
            it.key = 'normalSlot'
          }
          let text =
            it.key === 'normal_hole'
              ? `${typeMap.get(it.key)}`
              : `${typeMap.get(it.key)}: ${surfaceMap.get(it.value)}`

          if (it.key === 'normalSlot') {
            text += ` 槽长边: ${compareMap.get(it.rules.long_side_compare)}${
              it.rules.short_side_value
            }`
            text += ` 槽短边: ${compareMap.get(it.rules.short_side_compare)}${
              it.rules.short_side_value
            }`
          }
          if (it.key === 'normalHole' || it.key === 'normal_hole') {
            text += ` 孔直径：${compareMap.get(it.rules.compare)}${
              it.rules.value
            }`
          }
          if (it.key === 'LockHole') {
            text = '锁孔'
          }
          return text
        }
      )
    : ['']
}

/**
 * @desc 填充表格内容
 * @param index
 * @param i
 * @param item
 */
const fillContent = (index: number, i: string, item: any) => {
  const needSpecialValue = [
    'through_slot_two_side_cut',
    'throughTowSideToCut',
    'trimSide',
  ]
  let result = !index
    ? translateLang(keyMap.get(i))
    : (needSpecialValue.includes(i) ? spcialKeyMap : keyMap).get(
        String(data.value[item][i][index - 1])
      )
    ? translateLang(
        (needSpecialValue.includes(i) ? spcialKeyMap : keyMap).get(
          String(data.value[item][i][index - 1])
        )
      )
    : data.value[item][i][index - 1]
  if (
    !isShowSpecialRule.value &&
    Array.isArray(data.value[item][i]?.is_open) &&
    index
  ) {
    //特殊孔槽自定义特殊处理
    return data.value[item][i].is_open[index - 1]
      ? translateLang('开启')
      : translateLang('关闭')
  }
  // 用来处理指定材质
  if (Array.isArray(result)) {
    result = `"${result.join(',')}"`
  }
  return result
}
onMounted(() => {
  // 判断是否展示特殊孔槽自定义的具体内容规则
  if (data.value.holeFaceSetting?.custom_special_hole_slot_side) {
    isShowSpecialRule.value =
      !data.value.holeFaceSetting.custom_special_hole_slot_side.is_open
  }
  if (data.value.cuttingPunchingSetting?.non_through_slot_two_side_cut) {
    isShowSpecialRule.value =
      !data.value.cuttingPunchingSetting.non_through_slot_two_side_cut.is_open
  }
})
watch(
  () => props.data,
  (newVal) => {
    tableData.value = getkeys(newVal)
  },
  {
    deep: true,
    immediate: true,
  }
)

const data = computed(() => flatten(props.data))
// 扁平化对象属性(保持了顶层对象的结构，只对第二层及一下的层级进行处理)
const flatten = (obj: NestedObject) => {
  if (!obj || typeof obj !== 'object') {
    return obj
  }
  function flattenNested(nestedObj: NestedObject, prefix = ''): NestedObject {
    const flattened: NestedObject = {}
    for (const key in nestedObj) {
      const newKey = prefix ? `${prefix}-${key}` : key
      const value = nestedObj[key]
      if (
        typeof value === 'object' &&
        value !== null &&
        !Array.isArray(value)
      ) {
        Object.assign(flattened, flattenNested(value, newKey))
      } else {
        flattened[newKey] = value
      }
    }
    return flattened
  }
  const result = cloneDeep(obj)
  for (const key in obj) {
    const value = obj[key]
    for (const subKey in value) {
      const subValue = value[subKey]
      // 特殊孔槽规则不做处理
      if (
        subKey === 'custom_special_hole_slot_side' ||
        subKey === 'non_through_slot_two_side_cut'
      ) {
        continue
      }
      // 特殊孔槽自定义需求删除此选项
      if (subKey === 'processChainAndHoleOnBigPlaneBack') {
        delete result[key][subKey]
        continue
      }
      if (
        typeof subValue === 'object' &&
        subValue !== null &&
        !Array.isArray(subValue)
      ) {
        const flattened = flattenNested(subValue, subKey)
        result[key] = { ...result[key], ...flattened }
        delete result[key][subKey]
      }
    }
  }
  return result
}

const getExtraInfo = (item: string, index: number) => {
  if (index === 1) {
    return `(${translateLang('加入排版任务时')})`
  }
  if (index === 2) {
    return `(${translateLang('现在')})`
  }
  return ''
}

return { __sfc: true,keyMap, typeMap, surfaceMap, compareMap, spcialKeyMap, props, tableData, expandedArr, isShowSpecialRule, getkeys, handleExpandTitle, translateLang, fillSpecialHoleSlot, fillContent, data, flatten, getExtraInfo }
}

})